import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { guestGuard } from './core/auth/guest.guard';
import { AdminLayoutComponent } from './core/layout/admin-layout.component';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/presentation/login.page').then((m) => m.LoginPage),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'bus-management', pathMatch: 'full' },
      {
        path: 'bus-management',
        loadComponent: () =>
          import('./features/bus-management/presentation/bus-management.page').then(
            (m) => m.BusManagementPage,
          ),
      },
      {
        path: 'bus-management/operators/:operatorId',
        loadComponent: () =>
          import('./features/bus-management/presentation/operator-detail/operator-detail.page').then(
            (m) => m.OperatorDetailPage,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/presentation/settings.page').then(
            (m) => m.SettingsPage,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'bus-management' },
];
